// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Criteria from '../../state/criteria';
import LabeledCriteria from '../../../../shared/components/labeled-criteria';
import ReportDateCriteria from '../../../shared/components/date-criteria';

function handleCriteriaInputChange(criteria, event) {

    this.onCriteriaInputChange(criteria, event);

}

const CriteriaSectionTwo = props =>
    <div className='criteria-section-two'>
        <LabeledCriteria
            className='claim-number'
            isRequired={false}
            label='CLAIM_NUMBER'
            maxLength={17}
            onInputChange={handleCriteriaInputChange.bind(props, 'claimNumber')}
            placeholder='CLAIM_NUMBER'
            type='text'
            value={props.criteria.claimNumber}
        />
        <div className={`${props.isClaimCreatedRequired ? 'required' : ''}`}>
            <ReportDateCriteria
                dateRange={props.criteria.claimCreated}
                label='CREATED'
                onDateChange={props.onCriteriaDateChange}
            />
        </div>
    </div>;

CriteriaSectionTwo.displayName = 'CriteriaSectionTwo';
CriteriaSectionTwo.propTypes = {
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    isClaimCreatedRequired: PropTypes.bool.isRequired,
    onCriteriaDateChange: PropTypes.func.isRequired,
    onCriteriaInputChange: PropTypes.func.isRequired
};

export default CriteriaSectionTwo;



// WEBPACK FOOTER //
// ./src/reports/advanced-claim-summary/components/report-criteria/criteria-section-two.js